var render = function render(){var _vm=this,_c=_vm._self._c;return _c('dl',{staticClass:"integration-metadata"},_vm._l((_vm.visibleFields),function(value,key){return _c('div',{key:key},[_c('dt',[_vm._v(_vm._s(key))]),_c('dd',[_vm._v(_vm._s(value))])])}),0)
}
var staticRenderFns = []

export { render, staticRenderFns }